import { theme } from '@approvalmax/theme';
import styled from 'styled-components';

export const Root = styled.div`
    padding: 16px 0 36px;
`;

export const IconContainer = styled.div`
    margin-right: 15px;
    color: ${theme.color.red80};
`;
